import React, { useState } from 'react'
import { img } from '../assets/assets'
// import Countdown from 'react-countdown'
import '../assets/css/plugins/remixicon.css'
import '../assets/css/plugins/bootstrap.min.css'
import '../assets/css/plugins/swiper-bundle.min.css'
import '../assets/css/style.css'

const HomePage = () => {
    const [showMobileMenu, setShowMobileMenu] = useState(false)
    return (
        <div>
            <>
                <div className="overflow-hidden">
                    <header className="header__1 js-header" id="header">
                        <div className="container">
                            <div className="wrap js-header-wrapper">
                                <div className="header__logo">
                                    <a className="color_black" href="/">
                                        <img
                                            src={img.logos_seducetoken}
                                            alt="logo"
                                            id="logo_js_f"
                                        />
                                    </a>
                                </div>
                                {/* -- ================== -- */}
                                <div className="header__menu">
                                    <ul className="d-flex space-x-20">
                                        <li className="has_popup">
                                            <a className="color_black" href="/">
                                                Home
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="color_black"
                                                href="/about"
                                            >
                                                About Us
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="color_black"
                                                href="/team"
                                            >
                                                Our Team
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="color_black"
                                                href="/roadmap"
                                            >
                                                Roadmap
                                            </a>
                                        </li>
                                        <li onClick={() => window.open()}>
                                            <a
                                                className="color_black"
                                                href={img.whitepaper}
                                                // target="_blank"
                                                // rel="noreferrer"
                                            >
                                                Whitepaper
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="color_black"
                                                href="/ambassador"
                                            >
                                                Ambassadors
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="color_black"
                                                href="/contact"
                                            >
                                                Contact
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                {/* -- ================= -- */}
                                <div className="header__btns">
                                    <a
                                        className="btn btn-grad btn-sm"
                                        href="/dashboard"
                                    >
                                        <img
                                            src={img.icons_settings}
                                            alt="Dashboard"
                                            height="20px"
                                            width="20px"
                                        />
                                        Dashboard
                                    </a>
                                </div>
                                <div
                                    className="header__burger js-header-burger"
                                    onClick={() =>
                                        setShowMobileMenu(!showMobileMenu)
                                    }
                                ></div>
                                {showMobileMenu ? (
                                    <div className="header__mobile js-header-mobile">
                                        <div className="header__mobile__menu space-y-40">
                                            <ul className="d-flex space-y-20">
                                                <li className="has_popup">
                                                    <a
                                                        className="color_black"
                                                        href="/"
                                                    >
                                                        Home
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="color_black"
                                                        href="/about"
                                                    >
                                                        About Us
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="color_black"
                                                        href="/team"
                                                    >
                                                        Our Team
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="color_black"
                                                        href="/roadmap"
                                                    >
                                                        Roadmap
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="color_black"
                                                        href={img.whitepaper}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Whitepaper
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="color_black"
                                                        href="/ambassador"
                                                    >
                                                        Ambassadors
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className="color_black"
                                                        href="/contact"
                                                    >
                                                        Contact
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="space-y-20">
                                                <a
                                                    className="btn btn-grad btn-sm"
                                                    href="/dashboard"
                                                >
                                                    Dashboard
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    </header>
                    <div className="hero__index">
                        <img className="sh_1" src={img.icons_sh_1} alt="" />
                        <img className="sh_2" src={img.icons_sh_2} alt="" />
                        <img className="sh_3" src={img.icons_sh_3} alt="" />

                        <div className="container">
                            <div className="row align-items-center justify-content-center mb-70 mt-60">
                                <div className="col-lg-auto">
                                    <img
                                        className="img-fluid d-none d-md-block2 illus-main"
                                        src={img.logo_banner}
                                        alt=""
                                        width="500"
                                        height="600"
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <div className="hero__left space-y-20">
                                        <h1 className="hero__title">
                                            The Seduce Token!
                                        </h1>
                                        <p>
                                            Seduce Token is a thoroughgoing
                                            reformatory Binance Smart Chain
                                            token which will be a one-stop-shop
                                            for all adult entertainment needs.
                                        </p>
                                        <div
                                            className="space-x-20 d-flex flex-column flex-md-row
                        sm:space-y-20"
                                        >
                                            <a
                                                className="btn btn-primary"
                                                href="https://pancakeswap.finance/swap"
                                            >
                                                Buy now!
                                            </a>
                                            <a
                                                className="btn btn-white"
                                                // target="_blank"
                                                href="/audit"
                                            >
                                                Audit
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="section mt-100"></div>
                        <div className="container">
                            <div className="logos__wrap">
                                <div className="row align-items-center justify-content-between">
                                    <div className="col-lg-6">
                                        <h3 className="section__title md:mb-20">
                                            Seduce X{' '}
                                            <span className="spanblue">
                                                Caliente
                                            </span>
                                        </h3>
                                        <h4>
                                            Seduce is taking over caliente
                                            token.
                                        </h4>
                                        <p>
                                            Seduce Token will have an adult NFT
                                            marketplace before launch & staking
                                            platform on the day of launch.
                                        </p>
                                    </div>
                                    <div className="col-lg-auto">
                                        <a
                                            href="https://imgur.com/a/mTFE6uE"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                className="sdchart"
                                                src={img.sexxy}
                                                alt=""
                                                width="550px"
                                                height="550px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="container">
                            <div className="logos__wrap">
                                <div className="row align-items-center justify-content-between">
                                    <div className="col-lg-6">
                                        <h3 className="section__title md:mb-20">
                                            How We Reward Holders Of The Seduce
                                            Token.
                                        </h3>
                                        <p>
                                            Holders of Seduce token earn passive
                                            income in BNB.
                                        </p>
                                    </div>
                                    <div className="col-lg-auto">
                                        <a href="">
                                            <img
                                                src={img.bg_suggestion}
                                                alt=""
                                                width="160px"
                                                height="160px"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="container">
                            <div className="row md:space-y-30">
                                <div>
                                    <div className="container">
                                        <div className="hero__wallets pt-100 pb-50">
                                            <div className="space-y-20 d-flex flex-column align-items-center">
                                                <div className="logo text-center">
                                                    <img
                                                        src={
                                                            img.logos_seduce_home_logo
                                                        }
                                                        alt=""
                                                        width="100px"
                                                        height="100px"
                                                    />
                                                </div>
                                                <h2 className="text-center">
                                                    Presale
                                                </h2>
                                            </div>
                                        </div>
                                        <div className="row justify-content-center">
                                            <div className="col-lg-9">
                                                <div className="wallets">
                                                    <div className="row mb-20_reset">
                                                        <div className="col-lg-4">
                                                            <a
                                                                href="#"
                                                                className="box in__wallet space-y-10 countpad"
                                                                data-toggle="modal"
                                                                data-target="#popup_connected"
                                                            >
                                                                {/* -- <div className="logo">
                                            <img src="assets/img/icons/coibase.svg" alt="logo_community">
                                        </div> -- */}
                                                                <h5 className="text-center">
                                                                    Presale Date
                                                                </h5>
                                                                <p className="text-center">
                                                                    Soon to be
                                                                    announced.
                                                                </p>
                                                            </a>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <a
                                                                href="/dashboard"
                                                                className="box in__wallet space-y-10 countpad"
                                                            >
                                                                <h5 className="text-center">
                                                                    Whitelist
                                                                </h5>
                                                                <p className="text-center whitelist">
                                                                    Enter
                                                                    Whitelist.
                                                                </p>
                                                            </a>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <a
                                                                href="#"
                                                                className="box in__wallet space-y-10"
                                                                data-toggle="modal"
                                                                data-target="#popup_connected"
                                                            >
                                                                <h5 className="text-center">
                                                                    Private
                                                                    Sale.
                                                                </h5>
                                                                <p className="text-center">
                                                                    Private sale
                                                                    investors
                                                                    get 10%
                                                                    discount
                                                                    from launch
                                                                    price.
                                                                </p>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="community">
                            <div className="section__head space-y-20">
                                <h3 className="section__title text-center">
                                    Connect with us!
                                </h3>
                                <p className="section__text text-center">
                                    Reach out to use through your preferred
                                    social media platform. Click on any social
                                    media platform below and you will get
                                    redirected automatically!
                                </p>
                            </div>

                            <div className="community__items">
                                <div className="row justify-content-center mb-20_reset">
                                    <div className="col-md-3">
                                        <div className="item space-y-10">
                                            <div className="logo is_discord">
                                                <a href="https://discord.gg/kQYzKjEW5B">
                                                    <img
                                                        src={img.icons_discord}
                                                        alt="logo_community"
                                                    />
                                                </a>
                                            </div>
                                            <a
                                                className="color_black"
                                                href="https://discord.gg/kQYzKjEW5B"
                                            >
                                                <b>Discord</b>
                                            </a>
                                            <p className="text-center">
                                                Join our community of ambitious
                                                people and share ideas.
                                                Understand our progress and
                                                briefly updates.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="item space-y-10 paddingsocials">
                                            <div className="logo">
                                                <a
                                                    className="color_black"
                                                    href="https://instagram.com/seduce_token_official?utm_medium=copy_link"
                                                >
                                                    <img
                                                        src={
                                                            img.icons_instagram
                                                        }
                                                        alt="logo_community"
                                                        width="45px"
                                                        height="45px"
                                                    />
                                                </a>
                                            </div>
                                            <a
                                                className="color_black"
                                                href="https://instagram.com/seduce_token_official?utm_medium=copy_link"
                                            >
                                                <b>Instagram</b>
                                            </a>
                                            <p className="text-center">
                                                Connect with us through
                                                <span> Instagram </span> and
                                                view our daily posts.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="item space-y-10 paddingsocials">
                                            <div className="logo is_twitter">
                                                <a href="https://twitter.com/seducetokenbsc">
                                                    <img
                                                        src={img.icons_twitter}
                                                        alt="logo_community"
                                                    />
                                                </a>
                                            </div>
                                            <a
                                                className="color_black"
                                                href="https://twitter.com/seducetokenbsc"
                                            >
                                                <b>Twitter</b>
                                            </a>
                                            <p className="text-center">
                                                Stay updated with the seduce
                                                token through Twitter. Follow us
                                                now!
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="item space-y-10 paddingsocials">
                                            <div className="logo is_discord">
                                                <a href="https://t.me/seducetokenofficial">
                                                    <img
                                                        src={img.icons_telegram}
                                                        alt="logo_community"
                                                        width="45px"
                                                        height="45px"
                                                    />
                                                </a>
                                            </div>
                                            <a
                                                className="color_black"
                                                href="https://t.me/seducetokenofficial"
                                            >
                                                <b>Telegram</b>
                                            </a>
                                            <p className="text-center">
                                                Join our community on telegram
                                                for support queries and general
                                                discussions.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="container">
                        <div className="logos__wrap">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-lg-6">
                                    <h3 className="section__title md:mb-20">
                                        Do you need help regarding The Seduce
                                        Token?
                                    </h3>
                                </div>
                                <div className="col-lg-auto">
                                    <a className="btn btn-grad" href="/contact">
                                        Contact Us
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <footer className="footer__1">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 space-y-20">
                                    <div className="footer__logo">
                                        <a href="/">
                                            <img
                                                src={img.logos_seducetoken}
                                                alt="logo"
                                                id="logo_js_f"
                                            />
                                        </a>
                                    </div>

                                    <div>
                                        <ul className="footer__social space-x-10 mb-40">
                                            <li>
                                                <a href="https://instagram.com/seduce_token_official?utm_medium=copy_link">
                                                    <i className="ri-instagram-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/seducetokenbsc">
                                                    <i className="ri-twitter-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://discord.gg/ewekBsfU4B">
                                                    <i className="ri-discord-line"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://t.me/seducetokenofficial">
                                                    <i className="ri-telegram-line"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-6">
                                    <h6 className="footer__title">Project</h6>
                                    <ul className="footer__list">
                                        <li>
                                            <a href="/"> Home </a>
                                        </li>
                                        <li>
                                            <a href="/about">About us</a>
                                        </li>
                                        <li>
                                            <a href="/team"> Our Team</a>
                                        </li>
                                        <li>
                                            <a
                                                className="color_black"
                                                href="/roadmap"
                                            >
                                                Roadmap
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/ambassador">
                                                Ambassadors
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-lg-2 col-6">
                                    <h6 className="footer__title">Get help</h6>
                                    <ul className="footer__list">
                                        <li>
                                            <a href="/contact">Contact Us</a>
                                        </li>
                                        <li>
                                            <a
                                                href="/dashboard"
                                                target="_blank"
                                            >
                                                Buy Token
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-lg-2 col-6">
                                    <h6 className="footer__title">Documents</h6>
                                    <ul className="footer__list">
                                        <li>
                                            <a
                                                href={img.whitepaper}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Whitepaper
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <p className="copyright text-center">
                                © Seduce Token 2021. Created with love by
                                <a
                                    href="https://theclusterco.com"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    TheCluster
                                </a>
                                .
                            </p>
                        </div>
                    </footer>
                </div>
            </>
        </div>
    )
}

export default HomePage
